import VueRouter from 'vue-router';
import LoginPage from "@/components/login";
import HubPage from "@/components/hub";
import MapPage from "@/components/map";
import TrackerPage from "@/components/tracker";

export const routes = [
    {
        path: "/employee/",
        redirect: "/",
    },
    {
        path: "/hub",
        component: HubPage,
        name: 'hub',
    },
    {
        path: "/",
        component: LoginPage,
        name: 'login',
    },
    {
        path: "/map",
        component: MapPage,
        name: 'map',
    },
    {
        path: "/tracker",
        component: TrackerPage,
        name: 'tracker',
    },
]

const router = new VueRouter({
    history: VueRouter.createWebHistory,
    base: '/employee/',
    routes
})

export default router
